export default __webpack_public_path__ + "9f8a69f189f143fa470a0aab0a3701c3.png";